import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  formControl: {
    minWidth: "200px"
  }
});

export default useStyles;
